export default __webpack_public_path__ + "195cd07ace0d0eb60eba71499d4b9944.svg";